// extracted by mini-css-extract-plugin
module.exports = {"TitleSpacer":"_1G3XVy7Q3BEhRA_3fXXGkT","PageHeading":"Eg7JumTTa1bDgap8HE2Fr","Title":"_2Teg82gH7nQG1bwB6m1di8","PageHeadingAction":"_1coHWmjEutYzS6kBJL4tmt"};